import { Button } from "primereact/button";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export const ScreeningError = () => {
    const { t } = useTranslation("locale");

    const onClick = useCallback(
        () =>
            window.location.replace(
                process.env.REACT_APP_ID_PLATFORM_SCREENING_URL_ROOT ?? ""
            ),
        []
    );

    return (
        <div
            style={{
                height: "70vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            <div className="error-box" style={{ width: "21.75rem" }}>
                <div className="flex flex-column gap-4">
                    <h2>{t("screeningError.notAvailable")}</h2>
                    <p>{t("screeningError.sorryTheResource")}</p>
                    <Button
                        label={t("screeningError.goToScreening")}
                        onClick={onClick}
                    />
                </div>
            </div>
        </div>
    );
};
